import { render, staticRenderFns } from "./scrollable.vue?vue&type=template&id=eefe72cc"
import script from "./scrollable.vue?vue&type=script&lang=js"
export * from "./scrollable.vue?vue&type=script&lang=js"
import style0 from "./scrollable.vue?vue&type=style&index=0&id=eefe72cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports